import React from 'react';
import { Container, Typography, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';

const gridVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Education = ({ education }) => {
  return (
    <Container
      maxWidth="md"
      sx={{ my: 8 }}
      component={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={gridVariants}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Education
      </Typography>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        {education.map((edu, index) => (
          <Grid
            item
            xs={12}
            md={6}
            key={index}
            component={motion.div}
            variants={cardVariants}
          >
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {edu.degree}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {edu.institution} — {edu.year}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Education;
